"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Robot(props) {
    return (react_1.default.createElement("a", { id: props.name },
        react_1.default.createElement("img", null),
        react_1.default.createElement("h2", null, props.name.charAt(0).toUpperCase() + props.name.substring(1)),
        react_1.default.createElement("h3", null, "(" + props.season + " season)"),
        react_1.default.createElement("p", null, props.description)));
}
exports.default = Robot;
